<template>
  <div class="auth-main auth-main__reset-password">
    <main
      id="main"
      class="main--login"
      data-page-id="login"
    >
      <section class="section-login">
        <Header :is-whitelabel="isWhitelabel" />
        <div class="login-form-wrapper">
          <div class="loginv2-container p-b-20">
            <div class="row">
              <div
                class="login_logo"
                :class="{ 'login_logo--ringba': !isWhitelabel }"
              />
            </div>
            <PasswordResetForm
              v-if="!twoFactorAuthRequired"
              :action-status="actionStatus"
              @reset-password="onResetPassword"
            />
            <TwoFactorForm
              v-if="twoFactorAuthRequired"
              back-button-description="BACK_RESET_PASSWORD_LINK"
              :action-status="twoFactorActionStatus"
              @two-factor-verify="onResetPasswordTwoFactor"
            />
          </div>
        </div>
      </section>
      <Footer v-if="!isWhitelabel" />
      <WhitelabelFooter v-if="isWhitelabel" />
    </main>
  </div>
</template>

<script>
import Footer from '@/modules/auth/components/Footer';
import Header from '@/modules/auth/components/Header';
import PasswordResetForm from '@/modules/auth/components/PasswordReset/PasswordResetForm';
import TwoFactorForm from '@/modules/auth/components/Login/TwoFactorForm';
import WhitelabelFooter from '@/modules/auth/components/WhitelabelFooter';
import { mapState, mapActions } from 'vuex';
import { getStatus } from '@/store/helpers';

export default {
  components: { Footer, Header, PasswordResetForm, WhitelabelFooter, TwoFactorForm },
  props: {
    isWhitelabel: {
      type: Boolean,
      default() {
        return true;
      },
    },
    token: {
      type: String,
      default() {
        return null;
      },
    },
    resetId: {
      type: String,
      default() {
        return null;
      },
    }
  },
  computed: {
    ...mapState('auth', {
      actionStatus: (state) => getStatus(state, 'sendResetPasswordRequest'),
      twoFactorActionStatus: state => getStatus(state, 'sendResetPasswordRequestWithTwoFactor'),
      twoFactorAuthRequired: state => state.twoFactorAuthRequired
    })
  },
  methods: {
    ...mapActions('auth', [
      'sendResetPasswordRequest',
      'sendResetPasswordRequestWithTwoFactor'
    ]),

    onResetPassword(data) {
      const {password, confirmPassword} = data;
      const {token, resetId} = this;
      this.sendResetPasswordRequest({password, confirmPassword, token, id: resetId});
    },

    async onResetPasswordTwoFactor(data) {
      await this.sendResetPasswordRequestWithTwoFactor(data);
    }
  },
};
</script>

<style lang="scss" scoped>
.auth-main__reset-password {
  --component-login__welcome-sub-message: 'Reset your Password';
}
</style>